// extracted by mini-css-extract-plugin
export var svgPreview = "SVGPreview_svgPreview__DbuNF";
export var table = "SVGPreview_table__01+it";